import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Divider, Card } from "antd";
import { GetData } from "../../api/service";
import history from "../../history";
import { RightCircleOutlined } from "@ant-design/icons";
import StudentPlacement from "../Highlights/StudentPlacement";
import Testimonials from "../Testimonials";
import FacultyAchivement from "./FacultyAchivement";

const SECTIONS = [
  { title: "Faculty of Arts", value: "ARTS" },
  { title: "Faculty of Science", value: "SCIENCE" },
  { title: "Faculty of Commerce", value: "COMMERCE" },
  { title: "Faculty of Management", value: "OTHERS" },
];

export default function KnowYourFaculty() {
  const [dept, setDept] = React.useState([]);
  const [showAll, setShowAll] = React.useState({});

  React.useEffect(() => {
    GetData(`/getdepartments`).then((resp) => {
      setDept(resp);
    });
  }, []);

  const toggleShow = (key) => {
    setShowAll((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderDept = (stream) => {
    let list = dept.filter(
      (el) => el.stream === stream || (stream !== "COMMERCE" && el.is_dual)
    );

    return list.map((el, index) => {
      if (!showAll[stream] && index > 3) return null;

      return (
        <li key={index} style={styles.deptItem}>
          <a
            onClick={() => history.push(`/department/${el.dept_code}`)}
            style={styles.link}
          >
            <RightCircleOutlined style={styles.icon} />
            {el.dept_name}
          </a>
        </li>
      );
    });
  };

  return (
    <div style={styles.section}>
      <Grid container spacing={3}>
        
        {/* LEFT SIDE */}
        <Grid item xs={12} md={4}>
          <Divider style={styles.title}>Academic Faculty</Divider>

          <Grid container spacing={2}>
            {SECTIONS.map((sec, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Card style={styles.card}>
                  <Typography style={styles.cardTitle}>
                    {sec.title}
                  </Typography>

                  <ul style={styles.list}>
                    {renderDept(sec.value)}
                  </ul>

                  <div style={{ textAlign: "right" }}>
                    <span
                      onClick={() => toggleShow(sec.value)}
                      style={styles.showMore}
                    >
                      {!showAll[sec.value] ? "Show More" : "Show Less"}
                    </span>
                  </div>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* MIDDLE */}
        <Grid item xs={12} md={4}>
        <Divider style={styles.title}>Student Achievements</Divider>
          <StudentPlacement />
        </Grid>
        <Grid item xs={12} md={4}>
          <Divider style={styles.title}>Faculty Achievements</Divider>
          <FacultyAchivement />
        </Grid>

        {/* RIGHT */}
        {/* <Grid item xs={12} md={4}>
          <Divider style={styles.title}>Testimonials</Divider>
          <Testimonials type="TESTIMONIALS" showCaption={false} />
        </Grid> */}

      </Grid>
    </div>
  );
}

/* ================= INLINE CSS ================= */
const styles = {
  section: {
    padding: 20,
    background: "#f4f6f7",
  },

  title: {
    fontWeight: 700,
    fontSize: 20,
    color: "#1E3760",
    borderLeft: "4px solid #B22222",
    paddingLeft: 10,
  },

  card: {
    borderTop: "4px solid #B22222",
    borderRadius: 8,
    minHeight: 220,
    padding: 10,
    transition: "0.3s",
  },

  cardTitle: {
    fontWeight: 700,
    color: "#1E3760",
    marginBottom: 10,
  },

  list: {
    listStyle: "none",
    paddingLeft: 0,
  },

  deptItem: {
    marginBottom: 6,
  },

  link: {
    display: "flex",
    alignItems: "center",
    fontSize: 13,
    color: "#333",
    cursor: "pointer",
    textDecoration: "none",
  },

  icon: {
    marginRight: 8,
    fontSize: 12,
    color: "#B22222",
  },

  showMore: {
    color: "#B22222",
    cursor: "pointer",
    fontSize: 13,
  },
};